import React from "react";
import AdminSidebar from "../layouts/AdminSidebar";
import AdminTopBar from "../../components/AdminTopBar";

export default function AdminLayout({ children }) {
  return (
    <>
      <AdminTopBar />

      <div className="d-flex">
        {/* Sidebar */}
        <AdminSidebar />

        {/* Main Content */}
        <main className="admin-main flex-grow-1">{children}</main>
      </div>
    </>
  );
}
